import { FC, useEffect, useState } from "react";

import { ErrorSeverity, useErrorHandler } from "../../hooks/useErrorHandler";
import { ErrorBoundary } from "./ErrorBoundary";
import { ErrorModal } from "./ErrorModal";
import { ErrorPage } from "./ErrorPage";
import { ErrorToast } from "./ErrorToast";

export const ErrorWrapper: FC = ({ children }) => {
  const { error } = useErrorHandler(ErrorSeverity.HIGH);
  const [isAppReady, setIsAppReady] = useState(false);
  const [hasShownError, setHasShownError] = useState(false);

  useEffect(() => {
    // Delay showing the app to allow initial loading to complete
    const timer = setTimeout(() => {
      setIsAppReady(true);
    }, 2000); // 2 second delay to allow all initial loading to complete

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Only show error if app is ready and we haven't shown an error yet
    if (error && isAppReady && !hasShownError) {
      setHasShownError(true);
    }
  }, [error, isAppReady, hasShownError]);

  const shouldShowError = error && isAppReady && hasShownError;

  return (
    <ErrorBoundary>
      <ErrorModal />
      <ErrorToast />
      <ErrorPage />

      <div
        style={{
          display: shouldShowError ? "none" : "flex",
          flexDirection: "column",
          width: "100%",
          flex: 1,
        }}
      >
        {children}
      </div>
    </ErrorBoundary>
  );
};
